import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Layout/Header";
import SuperAdminSidebar from "./Layout/Sidebar";
import Footer from "../common/Layout/Footer";
import TitleHeader from "../common/TitleHeader";
import HouseIcon from "apollo-react-icons/House";
import MedicalCard from "apollo-react-icons/MedicalCard";
import FileAccountPlan from "apollo-react-icons/FileAccountPlan";
import Bell from "apollo-react-icons/Bell";
import Container from "apollo-react/components/Container";
import axiosInstance from "../../axiosInstance";

import CommonBreadcrumbs, { getPageName } from "../common/CommonBreadcrumbs";

const Layout = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").map(x => decodeURIComponent(x)).filter((x) => x);
  const [size, setSize] = useState([0, 0]);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [pageName, setPageName] = useState(getPageName("super-admin", location));

  const iconStyles = { fontSize: "36px", color: "#4D4D4D" };
  const pages = [
    { name: "home", icon: <HouseIcon style={{ ...iconStyles }} /> },
    { name: "users", icon: <MedicalCard style={{ ...iconStyles }} /> },
    { name: "endusers", icon: <MedicalCard style={{ ...iconStyles }} /> },
    { name: "roles", icon: <MedicalCard style={{ ...iconStyles }} /> },
    { name: "categories", icon: <MedicalCard style={{ ...iconStyles }} /> },
    { name: "reminders", icon: <Bell style={{ ...iconStyles }} /> },
    { name: "logs", icon: <FileAccountPlan style={{ ...iconStyles }} /> },
  ];

  useEffect(() => {
    const [width] = size;
    if (width < 850 && width !== 0) setIsSidebarCollapsed(true);
  }, [size]);

  useEffect(() => {
    const updateSize = () => {
      setSize([window.innerWidth, window.innerHeight]);
    };
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  
  useEffect(() => {
    const savedSidebarState = localStorage.getItem("isSidebarCollapsed") === "true";
    setIsSidebarCollapsed(savedSidebarState);
  }, []);

  const handleSidebarToggle = (collapsed) => {
    setIsSidebarCollapsed(collapsed);
    if (collapsed) {
      localStorage.setItem("isSidebarCollapsed", true);
    } else {
      localStorage.removeItem("isSidebarCollapsed");
    }
  };

    useEffect(() => {
      const updatePageName = async () => {
        const match = location.pathname.match(/^\/super-admin\/categories\/(\d+)/);
        if (match) {
          const categoryId = match[1];
          try {
            const response = await axiosInstance.get(`/api/categories/${categoryId}`);
            const categoryName = response.data.name;
            setPageName(`categories / ${categoryName}-users`);
          } catch (error) {
            console.error("Error fetching category name:", error);
            setPageName("categories/users");
          }
        } else {
          setPageName(getPageName("super-admin", location));
        }
      };
    
      updatePageName();
    }, [location]);

  return (
    <div>
      <Container
        className="main-container"
        style={{
          marginLeft: isSidebarCollapsed ? "64px" : "320px",
          width: isSidebarCollapsed ? "100%" : "75%",
        }}
      >
        <Header />

        <SuperAdminSidebar
          isSidebarCollapsed={isSidebarCollapsed}
          setIsSidebarCollapsed={handleSidebarToggle}
        />

        <main className="main-content">
          <CommonBreadcrumbs
            source="super-admin"
            pathnames={pathnames}
            location={location}
          />

          <TitleHeader
            title={pageName}
            icon={pages.find((page) => page.name === pageName)?.icon}
          />

          <Outlet />
        </main>

        <Footer />
      </Container>
    </div>
  );
};

export default Layout;
